import { useMemo } from 'react'
import { getLatestOrderStartTime } from 'lib/businessHour'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { BusinessTimeType } from 'types/store'
import { StoreCalendarType } from 'types/storeCalendar'

const useLatestOrderStartTime = (
  daysOfWeek: DayOfWeekType[],
  orderStartTime: BusinessTimeType,
  temporaryOpen?: StoreCalendarType
): string => {
  return useMemo(() => {
    // 臨時営業日であれば臨時営業日のオーダー開始時刻を返す
    if (temporaryOpen && temporaryOpen.order_start_time) {
      return temporaryOpen.order_start_time
    } else {
      return getLatestOrderStartTime(daysOfWeek, orderStartTime)
    }
  }, [daysOfWeek, orderStartTime, temporaryOpen])
}

export default useLatestOrderStartTime
